import type { FunctionComponent, ReactNode } from 'react';

type StatusIndicatorSize = 'sm' | 'md' | 'xs';
type StatusIndicatorWeight = 'medium' | 'semibold';

type StatusIndicatorProps = {
    readonly children: ReactNode;
    readonly className?: string;
    readonly 'data-testid'?: string;
    readonly icon: ReactNode;
    readonly size?: StatusIndicatorSize;
    readonly weight?: StatusIndicatorWeight;
};

const sizeClasses: Record<StatusIndicatorSize, string> = {
    md: 'text-sm',
    sm: 'text-xxs',
    xs: 'text-xs',
};

const weightClasses: Record<StatusIndicatorWeight, string> = {
    medium: 'font-medium',
    semibold: 'font-semibold',
};

export const StatusIndicator: FunctionComponent<StatusIndicatorProps> = ({
    children,
    className = 'text-gray-700',
    'data-testid': testId,
    icon,
    size = 'sm',
    weight = 'semibold',
}) => (
    <span
        className={`inline-flex min-h-[26px] items-center gap-xs tracking-tight in-data-[is-active=true]:!text-text-on-accent ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}
        data-testid={testId}
    >
        <span aria-hidden={true} className="inline-flex shrink-0 items-center justify-center">
            {icon}
        </span>
        <span className={`truncate in-data-[is-active=true]:!text-text-on-accent ${className}`}>{children}</span>
    </span>
);
